import { SearchOutlined } from '@ant-design/icons'
import { Input, message, Pagination } from 'antd'
import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import { Link, useHistory } from 'react-router-dom'
import Select from 'react-select'
import * as Yup from 'yup'
import httpService from '../../setup/http/httpServices'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import loc from '../data/Location.json'
import { ProfileAvatar } from '../modules/widgets/components/ProfileAvatar'

export function Shipping(props: any) {
  const history: any = useHistory()
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)

  const [show, setShow] = useState(false)
  const [delivery, setDelivery] = useState(history.location.state.campaignDetails.shippingMethod === "delivery")
  const [self, setSelf] = useState(history.location.state.campaignDetails.shippingMethod === "selfCheckout")
  const [influencerList, setinfluencerList] = useState([])
  const [totalCount, setTotalCount] = useState(null)
  const [selectedInfluencer, setSelectedInfluencer] = useState(null)
  const [s, setS] = useState('Andaman and Nicobar Islands')
  const [stateList, setStateList] = useState(['Rajasthan'])
  const [cityList, setCityList] = useState([])
  const getStates = () => {
    var states: any = []
    loc.map((l) => {
      var p = {
        value: l.State,
        label: l.State,
      }
      states.push(p)
    })
    setStateList(states)
    setS('Andaman and Nicobar Islands')
  }

  const getCities = () => {
    var c: any = []
    var ci: any = []
    loc.map((l) => {
      if (l.State === s) {
        c = l.Cities
        c.map((ct: any) => {
          var p = {
            value: ct,
            label: ct,
          }
          ci.push(p)
        })
      }
    })
    setCityList(ci)
  }

  useEffect(() => {

    getCities()
  }, [s])
  const handleClose = () => {
    setShow(false)
    setShow1(false)
    setShow2(false)
  }
  useEffect(() => {
    let interval;
    getAllInfluencer()
    interval = setInterval(() => {
      getAllInfluencer()
    }, 10000)
    getStates()
    getCities()
    return () => {
      clearInterval(interval);
    }
  }, [])
  const [addressList, setAddressList] = useState([])
  const getInfluencerDetails = (influencerId) => {
    httpService.getData(
      '/influencer-master/' + influencerId,
      (response) => {
        setAddressList(response.data.data.influencer?.basicInfo?.addressDetails)
      },
      (error) => { }
    )
  }
  const [enableSubmissionButton, setSubmissionButton] = useState(false);
  const getAllInfluencer = () => {
    httpService.getData(
      '/influencer-onboarding/' + `${props.campaignId}`,
      (response: any) => {
        let data = response.data.data
        // setAllData(data.influencers)
        setinfluencerList(data.influencers.shortListed)
        setTotalCount(data.counts ? data.counts : null)
        setSubmissionButton(data.influencers.shortListed.findIndex(x => x.oboardingStatus.shipped) > -1)
      },
      (error: any) => {
        message.error(error.message)
      }
    )
  }
  const checkoutSchema = Yup.object().shape({
    productLink: Yup.string().required('Product Link is required'),
    promoCode: Yup.string().required('Promo Code is required'),
  })
  const checkoutFormik = useFormik({
    initialValues: {
      productLink: '',
      promoCode: '',
    },
    validationSchema: checkoutSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      httpService.postData(
        '/influencer-onboarding/shipping/self-checkout/' + `${props.campaignId}`,
        values,
        (response: any) => {
          message.success('Shipping Details updated successfully')
          setShow1(false)
          getAllInfluencer()
        },
        (error: any) => {
          message.success('Shipping Details failed to update')
        }
      )
    },
  })

  const trackingSchema = Yup.object().shape({
    vendor: Yup.string().required('Vendor is required'),
    trackingId: Yup.string().required('Tracking ID is required'),
    trackingLink: Yup.string().required('Tracking Link is required'),
    // status: Yup.string().required('Status is required')
  })
  const vendorFormik = useFormik({
    initialValues: {
      vendor: '',
      trackingId: '',
      trackingLink: '',
      status: '',
    },
    validationSchema: trackingSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      httpService.postData(
        '/influencer-onboarding/shipping/delivery/update-tracking/' + selectedInfluencer._id,
        values,
        (response: any) => {
          message.success('Shipping Details updated successfully')
          setShow1(false)
          getAllInfluencer()
        },
        (error: any) => {
          message.success('Shipping Details failed to update')
        }
      )
    },
  })

  const addressSchema = Yup.object().shape({
    address: Yup.string().required('Address is required'),
    city: Yup.string().required('City ID is required'),
    state: Yup.string().required('State is required'),
    pincode: Yup.string().required('Pincode is required'),
  })
  const addressFormik = useFormik({
    initialValues: {
      address: '',
      city: '',
      state: '',
      pincode: '',
    },
    validationSchema: addressSchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      httpService.postData(
        '/influencer-master/address/' + selectedInfluencer.influencer._id,
        values,
        (response: any) => {
          message.success('Shipping address added successfully')
          setShow2(false)
          getAllInfluencer()
        },
        (error: any) => {
          message.success('Shipping address failed to update')
        }
      )
    },
  })
  const choice = (value: any) => {
    httpService.putData("/campaign-master/shipping-method/" + props.campaignId, {
      "shippingMethod": value === 'delivery' ? 'delivery' : "selfCheckout"
    }, (response: any) => {
      value === 'delivery' ? setDelivery(true) : setSelf(true)
    }, (error: any) => {
      message.error(error?.message);
    })
  }
  return (
    <>
      <div>
        {!delivery && !self && (
          <div>
            <div className='w-100 flex mt-20'>
              <h1 className='fw-bolder'>Choose Shipping method</h1>
            </div>
            <div className='w-100 flex'>
              <p className='fs-3 text-gray-400 w-600px'>
                Based on the shippng options, product will be delivered to the influencer address.
                Once selected selection cannot be reversed.
              </p>
            </div>
            <div className='flex'>
              <div className='basicDiv w-25'>
                <KTSVG
                  className='svg-icon svg-icon-5x flex'
                  path={toAbsoluteUrl('/media/icons/Custom/courier.svg')}
                />
                <div className='w-100 flex m20'>
                  <h3>Offline (Delivery to doorstep)</h3>
                </div>
                <div className='w-100 flex'>
                  <p className='w-350px text-gray-400 text-center'>
                    The product(s) will be delivered physically on the influencer's shipping
                    address.
                  </p>
                </div>
                <div className='w-100 flex'>
                  <button
                    className='btn btn-primary fs-6 dialogButton w-75 h-50px m20 '
                    onClick={() => {
                      choice('delivery')
                    }}
                  >
                    Proceed
                  </button>
                </div>
              </div>

              <div className='basicDiv w-25 ms-5'>
                <KTSVG
                  className='svg-icon svg-icon-5x flex'
                  path={toAbsoluteUrl('/media/icons/Custom/creditCard.svg')}
                />
                <div className='w-100 flex m20'>
                  <h3>Online (Digitally redeemable code)</h3>
                </div>
                <div className='w-100 flex'>
                  <p className='w-350px text-gray-400 text-center'>
                    The influencer can make an online purchase using the promotional code.
                  </p>
                </div>
                <div className='w-100 flex'>
                  <button
                    className='btn btn-primary fs-6 dialogButton w-75 h-50px m20 '
                    onClick={() => {
                      choice('self')
                    }}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {delivery && (
          <div className='w-100 me-20 pe-20'>
            <div className='TableDiv w-100'>
              <div className='TableHeader w-100 justify-content-between'>
                <h3 className='mb-0 w-900px'>
                  Shipping Method Offline (Delivery to doorstep)
                  <p className='m-0 text-gray-400 fs-7'>{influencerList.length} Influencers</p>
                </h3>
                <div className='d-flex align-items-right justify-content-right'>
                  <link
                    href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
                    rel='stylesheet'
                  />
                  <Input
                    placeholder='Search influencer'
                    className='form-control-solid rounded-4 bg-gray-100 rounded w-250px h-38px'
                    prefix={
                      <>
                        <SearchOutlined />
                      </>
                    }
                  />
                </div>
                {enableSubmissionButton && <div className='flex ms-8px'>
                  <Link
                    to={{
                      pathname: '/campaign/contract',
                      state: {
                        ...history.location.state,
                        ...{ breadcrums: ['Campaigns', 'Content Submission'] },
                      },
                    }}
                  >
                    <button className='btn TableButton btn-pink text-white'>
                      Content Submission
                    </button>
                  </Link>
                </div>
                }
              </div>
              <div className='card-body mt-0 p-0 h-75'>
                {/* begin::Table container */}
                <div className='table-responsive'>
                  {/* begin::Table */}
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    {/* begin::Table head */}
                    <thead>
                      <tr className='fw-bolder fs-7 text-muted'>
                        <th className='bg-primary bg-opacity-5 min-w-200px'>
                          <span className='d-flex ms-7'>
                            Influencer
                            {/* <a
                          className={sort1}
                          onClick={() => {
                            if (sort1 == 'rotate-90 ms-2') {
                              setSort1('rotate-270 ms-2')
                            } else {
                              setSort1('rotate-90 ms-2')
                            }
                          }}
                        >
                          <KTSVG
                            className='svg-icon svg-icon-sm svg-icon-gray-700 flex h-20px pointer'
                            path={toAbsoluteUrl('/media/icons/Custom/SideArrow.svg')}
                          />
                        </a> */}
                          </span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-500px'>
                          <span className='d-flex'>
                            Address
                            {/* <a
                          className={sort2}
                          onClick={() => {
                            if (sort2 == 'rotate-90 ms-2') {
                              setSort2('rotate-270 ms-2')
                            } else {
                              setSort2('rotate-90 ms-2')
                            }
                          }}
                        >
                          <KTSVG
                            className='svg-icon svg-icon-sm svg-icon-gray-700 flex h-20px pointer'
                            path={toAbsoluteUrl('/media/icons/Custom/SideArrow.svg')}
                          />
                        </a> */}
                          </span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>City</span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>State</span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>Pincode</span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>Tracking</span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>Shipped</span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>Delivered</span>
                        </th>
                      </tr>
                    </thead>
                    {/* end::Table head */}
                    {/* begin::Table body */}
                    <tbody>
                      {influencerList.map((data: any) => (
                        <tr className=''>
                          <td className='fw-bolder ps-8'>
                            <span className='flex justify-content-start w-100'>
                              <ProfileAvatar
                                src={
                                  data?.influencer.basicInfo.avatar
                                    ? data?.influencer.basicInfo.avatar
                                    : null
                                }
                                className='w-100 rounded-circle ml-2 '
                                name={
                                  data?.influencer.basicInfo.name
                                    ? data?.influencer.basicInfo.name[0].toUpperCase()
                                    : 'NA'
                                }
                              ></ProfileAvatar>

                              <span className='fs-6 ms-4 mt-1 '>
                                <label className='fs-7 text-gray-400 m-0'>
                                  {data?.influencer.basicInfo.name}
                                </label>
                              </span>
                            </span>
                          </td>
                          <td>
                            {data?.shipping?.addressDetail ? (
                              <>
                                {data?.shipping?.addressDetail.address}
                              </>
                            ) : (
                              <button
                                className='btn btn-primary fs-6 dialogButton w-50 '
                                onClick={() => {
                                  getInfluencerDetails(data.influencer._id)
                                  setSelectedInfluencer(data)
                                  setShow2(true)
                                }}
                              >
                                + Add Address
                              </button>
                            )}
                          </td>
                          <td>{data?.shipping?.addressDetail?.city || 'NA'}</td>
                          <td>{data?.shipping?.addressDetail?.state || 'NA'}</td>
                          <td>{data?.shipping?.addressDetail?.pincode || 'NA'}</td>
                          <td>
                            {data?.shipping?.delivery?.tracking ?
                              <a href={data?.shipping?.delivery?.tracking?.trackingLink} target="parent">
                                <div className='tracking-btn'>
                                  {data?.shipping?.delivery?.tracking?.trackingId}
                                </div>
                              </a> :
                              <button
                                className='btn bg-pink bg-opacity-25 text-pink fs-6 dialogButton w-100 h-50px'
                                onClick={() => {
                                  setSelectedInfluencer(data)
                                  setShow1(true)
                                }}
                              >
                                + Add Tracking Details
                              </button>
                            }
                          </td>
                          <td className=''>
                            <span
                              className={
                                data?.shipping?.delivery?.status === 'delivered' ||
                                  data?.shipping?.delivery?.status === 'shipped'
                                  ? 'bg-success w-35px h-35px flex rounded-circle'
                                  : 'bg-gray-100 w-35px h-35px flex rounded-circle'
                              }
                            >
                              <KTSVG
                                className={
                                  data?.shipping?.delivery?.status === 'delivered' ||
                                    data?.shipping?.delivery?.status === 'shipped'
                                    ? 'svg-icon svg-icon-white flex'
                                    : 'svg-icon svg-icon-dark flex'
                                }
                                path={toAbsoluteUrl('/media/icons/Custom/Active.svg')}
                              />
                            </span>
                          </td>
                          <td className=''>
                            <span
                              className={
                                data?.shipping?.received
                                  ? 'bg-success w-35px h-35px flex rounded-circle'
                                  : 'bg-gray-100 w-35px h-35px flex rounded-circle'
                              }
                            >
                              <KTSVG
                                className={
                                  data?.shipping?.received
                                    ? 'svg-icon svg-icon-white flex'
                                    : 'svg-icon svg-icon-dark flex'
                                }
                                path={toAbsoluteUrl('/media/icons/Custom/Active.svg')}
                              />
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>

                    {/* end::Table body */}
                  </table>
                  <Modal
                    show={show1}
                    onHide={handleClose}
                    aria-labelledby='contained-modal-title-vcenter'
                    centered
                  >
                    <Modal.Body>
                      <h2>Shipping </h2>

                      <h6 className='fw-bold m24'>Status</h6>
                      <form noValidate onSubmit={vendorFormik.handleSubmit}>
                        <Select
                          name='status'
                          // {...vendorFormik.getFieldProps('status')}
                          placeholder='Status'
                          styles={{
                            menuList: (provided, state) => ({
                              ...provided,
                              height: '100px',
                            }),
                          }}
                          onChange={(e) => vendorFormik.setFieldValue('status', e.value)}
                          // options={["Shipped", "Delivered"]}
                          options={[
                            { label: 'Shipped', value: 'shipped' },
                            { label: 'Delivered', value: 'delivered' },
                          ]}
                          className='text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                        />
                        <h6 className='fw-bold m16'>Vendor</h6>
                        <input
                          type='text'
                          {...vendorFormik.getFieldProps('vendor')}
                          placeholder='Vendor'
                          className='form-control form-control-solid rounded-4 bg-gray-100'
                        />
                        <h6 className='fw-bold m16'>Tracking Link</h6>
                        <input
                          type='text'
                          {...vendorFormik.getFieldProps('trackingLink')}
                          placeholder='Tracking Link'
                          className='form-control form-control-solid rounded-4 bg-gray-100'
                        />
                        <h6 className='fw-bold m16'>Tracking ID</h6>
                        <input
                          type='text'
                          {...vendorFormik.getFieldProps('trackingId')}
                          placeholder='Tracking ID'
                          className='form-control form-control-solid rounded-4 bg-gray-100'
                        />
                        <div className='d-flex'>
                          <button
                            type='button'
                            className='btn btn-gray-100 text-dark fs-6 dialogButton w-100 h-50px m20'
                            onClick={() => setShow1(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type='submit'
                            className='btn btn-primary fs-6 dialogButton w-100 h-50px m20 ms-5'
                          // onClick={() => setShow(false)}
                          >
                            Save Changes
                          </button>
                        </div>
                      </form>
                    </Modal.Body>
                  </Modal>
                  <div className='d-flex ms-5 me-10 justify-content-between align-items-end flex-wrap mb-10'>
                    <span className='text-muted pb-2'>
                      Page 1 of 10
                      {/* {Math.floor(paginationCount % influencerListParams.limit) === 0
                        ? Math.floor(paginationCount / influencerListParams.limit)
                        : Math.floor(paginationCount / influencerListParams.limit) + 1} */}
                    </span>
                    <div className='d-flex flex-wrap '>
                      <Pagination
                        className=''
                        pageSize={10}
                        defaultCurrent={1}
                        total={10}
                      // onChange={(e) =>
                      //   setinfluencerListParams({ ...influencerListParams, ...{ page: e } })
                      // }
                      />
                    </div>
                  </div>
                  {/* end::Table */}
                </div>
                {/* end::Table container */}
              </div>
            </div>
          </div>
        )}
        {self && (
          <div className='w-100 me-20 pe-20 d-flex'>
            <div className='ms-5 w-25'>
              <div className='basicDiv'>
                <h3 className='mb-0'>Ordering Info</h3>
                <p className='m-0 text-gray-400 fs-7'>This info will be displayed to influencer</p>
                <form noValidate onSubmit={checkoutFormik.handleSubmit}>
                  <h6 className='fw-bold required m24'>Product Link</h6>
                  <input
                    type='text'
                    {...checkoutFormik.getFieldProps('productLink')}
                    placeholder='Product Link'
                    className='form-control form-control-solid rounded-4 bg-gray-100'
                  />
                  <h6 className='fw-bold required m16'>Promotional Code</h6>
                  <input
                    type='text'
                    {...checkoutFormik.getFieldProps('promoCode')}
                    placeholder='Promotional Code'
                    className='form-control form-control-solid rounded-4 bg-gray-100'
                  />
                  <button type='submit' className='btn btn-primary dialogButton w-100 h-50px m20'>
                    Update Details
                  </button>
                </form>
              </div>
            </div>
            <div className='TableDiv w-75'>
              <div className='TableHeader w-100 justify-content-between'>
                <h3 className='mb-0'>
                  Shipping Method Online (Digitally redeemable code)
                  <p className='m-0 text-gray-400 fs-7'>{influencerList.length} Influencers</p>
                </h3>
                <div className='d-flex align-items-center justify-content-start'>
                  <link
                    href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css'
                    rel='stylesheet'
                  />
                  <Input
                    placeholder='Search influencer'
                    className='form-control-solid rounded-4 bg-gray-100 rounded w-250px h-38px'
                    prefix={
                      <>
                        <SearchOutlined />
                      </>
                    }
                  />
                </div>
              </div>
              <div className='card-body mt-0 p-0 h-75'>
                {/* begin::Table container */}
                <div className='table-responsive'>
                  {/* begin::Table */}
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    {/* begin::Table head */}
                    <thead>
                      <tr className='fw-bolder fs-7 text-muted'>
                        <th className='bg-primary bg-opacity-5 min-w-200px'>
                          <span className='d-flex ms-7'>
                            Influencer
                            {/* <a
                          className={sort1}
                          onClick={() => {
                            if (sort1 == 'rotate-90 ms-2') {
                              setSort1('rotate-270 ms-2')
                            } else {
                              setSort1('rotate-90 ms-2')
                            }
                          }}
                        >
                          <KTSVG
                            className='svg-icon svg-icon-sm svg-icon-gray-700 flex h-20px pointer'
                            path={toAbsoluteUrl('/media/icons/Custom/SideArrow.svg')}
                          />
                        </a> */}
                          </span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-500px'>
                          <span className='d-flex'>
                            Address
                            {/* <a
                          className={sort2}
                          onClick={() => {
                            if (sort2 == 'rotate-90 ms-2') {
                              setSort2('rotate-270 ms-2')
                            } else {
                              setSort2('rotate-90 ms-2')
                            }
                          }}
                        >
                          <KTSVG
                            className='svg-icon svg-icon-sm svg-icon-gray-700 flex h-20px pointer'
                            path={toAbsoluteUrl('/media/icons/Custom/SideArrow.svg')}
                          />
                        </a> */}
                          </span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>City</span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>State</span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>Pincode</span>
                        </th>
                        <th className='bg-primary bg-opacity-5 min-w-100px'>
                          <span className='d-flex'>Received</span>
                        </th>
                      </tr>
                    </thead>
                    {/* end::Table head */}
                    {/* begin::Table body */}
                    <tbody>
                      {influencerList.map((data: any) => (
                        <tr className=''>
                          <td className='fw-bolder ps-8'>
                            <span className='flex justify-content-start w-100'>
                              <ProfileAvatar
                                src={
                                  data?.influencer.basicInfo.avatar
                                    ? data?.influencer.basicInfo.avatar
                                    : null
                                }
                                className='w-100 rounded-circle ml-2 '
                                name={
                                  data?.influencer.basicInfo.name
                                    ? data?.influencer.basicInfo.name[0].toUpperCase()
                                    : 'NA'
                                }
                              ></ProfileAvatar>

                              <span className='fs-6 ms-4 mt-1 '>
                                <label className='fs-7 text-gray-400 m-0'>
                                  {data?.influencer.basicInfo.name}
                                </label>
                              </span>
                            </span>
                          </td>
                          <td>
                            {data?.shipping.addressDetail ? (
                              <>
                                {data?.shipping.addressDetail.address}
                              </>
                            ) : (
                              <button
                                className='btn btn-primary fs-6 dialogButton w-50 '
                                onClick={() => {
                                  getInfluencerDetails(data.influencer._id)
                                  setSelectedInfluencer(data)
                                  setShow2(true)
                                }}
                              >
                                + Add Address
                              </button>
                            )}
                          </td>
                          <td>{data?.shipping?.addressDetail?.city || 'NA'}</td>
                          <td>{data?.shipping?.addressDetail?.state}</td>
                          <td>{data?.shipping?.addressDetail?.pincode}</td>
                          <td className=''>
                            <span
                              className={
                                data?.shipping?.delivery?.status === 'recieved'
                                  ? 'bg-success w-35px h-35px flex rounded-circle'
                                  : 'bg-gray-100 w-35px h-35px flex rounded-circle'
                              }
                            >
                              <KTSVG
                                className={
                                  data?.shipping?.delivery?.status === 'recieved'
                                    ? 'svg-icon svg-icon-white flex'
                                    : 'svg-icon svg-icon-dark flex'
                                }
                                path={toAbsoluteUrl('/media/icons/Custom/Active.svg')}
                              />
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>

                    {/* end::Table body */}
                  </table>
                  <div className='d-flex ms-5 me-10 justify-content-between align-items-end flex-wrap mb-10'>
                    <span className='text-muted pb-2'>
                      Page 1 of 10
                      {/* {Math.floor(paginationCount % influencerListParams.limit) === 0
                        ? Math.floor(paginationCount / influencerListParams.limit)
                        : Math.floor(paginationCount / influencerListParams.limit) + 1} */}
                    </span>
                    <div className='d-flex flex-wrap '>
                      <Pagination
                        className=''
                        pageSize={10}
                        defaultCurrent={1}
                        total={10}
                      // onChange={(e) =>
                      //   setinfluencerListParams({ ...influencerListParams, ...{ page: e } })
                      // }
                      />
                    </div>
                  </div>
                  {/* end::Table */}
                </div>
                {/* end::Table container */}
              </div>
            </div>
          </div>
        )}
        <Modal
          show={show}
          onHide={handleClose}
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Body>
            <h2>Add an Address</h2>
            <h6 className='fw-bold required m20'>Address</h6>
            <form noValidate onSubmit={addressFormik.handleSubmit}>
              <textarea
                {...addressFormik.getFieldProps('address')}
                placeholder='Address'
                className='form-control form-control-solid rounded-4 bg-gray-100 h-70px'
              />
              <h6 className='fw-bold required m16'>State</h6>
              <Select
                options={stateList}
                // value={state}
                isMulti={false}
                name='state'
                placeholder='State'
                styles={{
                  menuList: (provided, state) => ({
                    ...provided,
                    height: '100px',
                  }),
                }}
                onChange={(e: any) => {
                  addressFormik.setFieldValue('state', e.value)
                  setS(e.value)
                  // setState(e)
                }}
                className='text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
              />
              <h6 className='fw-bold required m16'>City</h6>
              <Select
                options={cityList}
                // value={['Maha', 'Delhi']}
                isMulti={false}
                name='city'
                placeholder='City'
                styles={{
                  menuList: (provided, state) => ({
                    ...provided,
                    height: '100px',
                  }),
                }}
                onChange={(e) => {
                  addressFormik.setFieldValue('city', e.value)
                }}
                className='text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
              />
              <h6 className='fw-bold required m16'>Pincode</h6>
              <input
                type='text'
                placeholder='Pincode'
                {...addressFormik.getFieldProps('pincode')}
                className='form-control form-control-solid rounded-4 bg-gray-100'
              />
              <div className=''>
                <button
                  className='btn btn-primary fs-6 dialogButton w-100 h-50px m20 '
                  onClick={() => setShow(false)}
                >
                  Add Address
                </button>
                <div className='w-100 d-flex m16 justify-content-center pb-2'>
                  <a
                    className='link-primary fs-6 fw-bolder'
                    onClick={() => {
                      setShow(false)
                      setShow2(true)
                    }}
                  >
                    Select from an Existing Address
                  </a>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
        <Modal
          show={show2}
          onHide={handleClose}
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Body>
            <h2>Select from an Existing Address</h2>
            <form noValidate onSubmit={addressFormik.handleSubmit}>
              {addressList.map((x) => (
                <div className='w-100 m-2 bg-gray-100 p-3 pt-5 pb-5 rounded d-flex'>
                  <div className='form-check form-check-custom form-check-solid form-check-primary'>
                    <input
                      className='form-check-input'
                      type='radio'
                      value='Address'
                      id='flexRadioDefault'
                      name='platform'
                      checked={x.isDefault}
                      onChange={(e) => {
                        addressList.map((address) => {
                          if (address._id === x._id) address.isDefault = true
                          else address.isDefault = false
                        })
                        setTimeout(() => {
                          setAddressList([...addressList])
                        }, 100)
                      }}
                    />
                  </div>
                  <p className='ms-5 mb-0'>
                    {x.address}, {x.city}, {x.state}, {x.pinCode}
                  </p>
                </div>
              ))}

              <div className=''>
                <button
                  className='btn btn-primary fs-6 dialogButton w-100 h-50px m20 '
                  onClick={() => {
                    if (addressList.length > 0)
                      httpService.postData(
                        '/influencer-onboarding/shipping/update-address/' +
                        selectedInfluencer._id,
                        {
                          addressId: addressList.find((x) => x.isDefault)._id,
                        },
                        (response) => {
                          message.success('Influencer address updated successfully.')
                          getAllInfluencer()
                          setShow2(false)
                        },
                        (error) => {
                          message.error('Something went wrong')
                        }
                      )
                  }}
                >
                  Select Address
                </button>
                <div className='w-100 d-flex m16 justify-content-center pb-2'>
                  <a
                    className='link-primary fs-6 fw-bolder'
                    onClick={() => {
                      setShow2(false)
                      setShow(true)
                    }}
                  >
                    Add a different delivery address
                  </a>
                </div>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  )
}
